(function () {
  'use strict';

  function isUnlocked(storageKey) {
    try {
      return localStorage.getItem(storageKey) === '1';
    } catch (e) {
      return false;
    }
  }

  function openKlaviyoForm(formId) {
    if (!formId) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  function unlockRoot(root) {
    var storageKey = root.dataset.storageKey || 'ami_download';
    var url = root.dataset.pendingDocUrl || '';

    try {
      localStorage.setItem(storageKey, '1');
    } catch (e) {}

    root.classList.add('is-unlocked');
    delete root.dataset.pendingDocUrl;

    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  function handleDocClick(root, btn) {
    var storageKey = root.dataset.storageKey || 'ami_download';
    var klaviyoFormId = root.dataset.klaviyoForm || '';
    var url = (btn.getAttribute('data-doc-url') || '').trim();

    if (isUnlocked(storageKey)) {
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
      return;
    }

    root.dataset.pendingDocUrl = url;
    openKlaviyoForm(klaviyoFormId);
  }

  function initHintSavDocs(root) {
    if (!root || root.dataset.hintSavInit === '1') return;
    root.dataset.hintSavInit = '1';

    var storageKey = root.dataset.storageKey || 'ami_download';
    var buttons = root.querySelectorAll('.hint-sav-contact__doc--gated');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        handleDocClick(root, btn);
      });
    });

    if (isUnlocked(storageKey)) {
      root.classList.add('is-unlocked');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-hint-sav-docs]').forEach(initHintSavDocs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-hint-sav-docs]');
    if (root) initHintSavDocs(root);
  });

  window.addEventListener('klaviyoForms', function (event) {
    if (!event.detail || event.detail.type !== 'submit') return;

    document.querySelectorAll('[data-hint-sav-docs]').forEach(function (root) {
      if (root.dataset.pendingDocUrl) {
        unlockRoot(root);
      }
    });
  });
})();
